import { useEffect, useState } from "react";
import { X } from "lucide-react";

/**
 * Minimal RGPD-friendly cookie banner.
 * We only use essential cookies (session, theme, lang) so the banner is informative
 * and gives a clear opt-out reminder. No tracking cookies are set without consent.
 */
export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const ack = localStorage.getItem("tk_cookies_ack");
        if (!ack) setVisible(true);
    }, []);

    const accept = () => {
        localStorage.setItem("tk_cookies_ack", "ok");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-4 left-4 right-4 sm:right-auto sm:left-6 sm:bottom-6 sm:max-w-sm z-[60] tk-card p-4 sm:p-5 tk-shadow-elev"
            role="dialog"
            aria-label="Bandeau cookies"
        >
            <div className="flex items-start gap-3">
                <div className="flex-1 text-sm">
                    <p className="font-semibold text-[#1D1D1F]">Cookies essentiels uniquement</p>
                    <p className="mt-1 text-[#86868B] text-[13px] leading-relaxed">
                        Nous utilisons uniquement des cookies nécessaires au fonctionnement du service
                        (session, préférences). Aucun tracking publicitaire.{" "}
                        <a href="/confidentialite" className="text-[#007AFF] hover:underline">
                            En savoir plus
                        </a>
                    </p>
                    <div className="mt-3 flex gap-2">
                        <button
                            onClick={accept}
                            data-testid="cookie-accept"
                            className="tk-btn tk-btn-primary text-xs px-4 py-2"
                        >
                            J&apos;ai compris
                        </button>
                    </div>
                </div>
                <button
                    onClick={accept}
                    className="text-[#86868B] hover:text-[#1D1D1F] transition shrink-0"
                    aria-label="Fermer"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}
